var _rect, _g, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoProfileRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 26,
    viewBox: "0 0 26 26",
    width: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 25,
    rx: 12.5,
    width: 25,
    x: 0.5,
    y: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "#0d8b69",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13 3.83333c-5.06261 0-9.16667 4.10405-9.16667 9.16667 0 5.0626 4.10406 9.1666 9.16667 9.1666 5.0626 0 9.1667-4.104 9.1667-9.1666 0-5.06262-4.1041-9.16667-9.1667-9.16667zm-10 9.16667c0-5.52285 4.47715-10 10-10 5.5228 0 10 4.47715 10 10 0 5.5228-4.4772 10-10 10-5.52285 0-10-4.4772-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.65899 8.1935c.16559-.1598.42941-.1551.58921.01049.7713.79934 1.7679 1.34479 2.8569 1.56376 1.0891.21897 2.219.10108 3.2394-.338.2114-.09095.4564.00667.5474.21805s-.0067.4565-.218.5474c-1.1759.506-2.478.6419-3.733.3895-1.2551-.2523-2.4035-.88088-3.29239-1.80204-.1598-.16559-.1551-.42936.01048-.58916z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 7.16666c-1.7259 0-3.125 1.39911-3.125 3.12504 0 1.7258 1.3991 3.125 3.125 3.125s3.125-1.3992 3.125-3.125c0-1.72593-1.3991-3.12504-3.125-3.12504zm-3.95833 3.12504c0-2.18617 1.77223-3.95837 3.95833-3.95837s3.9583 1.7722 3.9583 3.95837c0 2.1861-1.7722 3.9583-3.9583 3.9583s-3.95833-1.7722-3.95833-3.9583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.66168 15.6347c.99862-.6324 2.15632-.9681 3.33832-.9681s2.3397.3357 3.3383.9681c.9986.6323 1.7971 1.5353 2.3025 2.6038.0984.208.0095.4564-.1985.5548s-.4564.0095-.5548-.1985c-.4379-.9258-1.1297-1.7082-1.995-2.2561s-1.8684-.8388-2.8925-.8388-2.0272.2909-2.8925.8388c-.86526.5479-1.55711 1.3303-1.99501 2.2561-.09839.208-.34679.2969-.55481.1985-.20803-.0984-.2969-.3468-.1985-.5548.50539-1.0685 1.30388-1.9715 2.3025-2.6038z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 25,
    rx: 12.5,
    stroke: "#fff",
    width: 25,
    x: 0.5,
    y: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoProfileRound);
export default __webpack_public_path__ + "static/media/ico_profile_round.2a91fd761654ed6d311431dfc068011f.svg";
export { ForwardRef as ReactComponent };